import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import AddEstatePageWidget  from './addEstatePageWidget'
function AddEstate() {
  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m9'>
                {/* <div className='container'> */}
                   <AddEstatePageWidget/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default AddEstate